// extracted by mini-css-extract-plugin
export default {"over-relay":"Overrelay_over-relay__egFLc"};